import React from 'react';

import img1 from '../../../assets/status_1.svg';
import img2 from '../../../assets/status_2.svg';
import img3 from '../../../assets/status_3.svg';
import img4 from '../../../assets/status_4.svg';
import img5 from '../../../assets/status_5.svg';

import { Container, CardItem, Img, Text } from './styles';

const RefuelStatus: React.FC = () => {
  const statusItems = [
    {
      id: 1,
      img: img1,
      title: 'Processando',
      active: true,
      isSelected: true,
    },
    {
      id: 2,
      img: img2,
      title: 'Pedido criado',
      active: false,
      isSelected: false,
    },
    {
      id: 3,
      img: img3,
      title: 'Em análise',
      active: false,
      isSelected: false,
    },
    {
      id: 4,
      img: img4,
      title: 'Rota de entrega',
      active: false,
      isSelected: false,
    },
    {
      id: 5,
      img: img5,
      title: 'Pedido entregue',
      active: false,
      isSelected: false,
    },
  ];

  return (
    <Container>
      {statusItems.map((item) => (
        <CardItem
          key={item.id}
          active={item.active}
          isSelected={item.isSelected}
        >
          <Img src={item.img} alt={item.title} />
          <Text>{item.title}</Text>
        </CardItem>
      ))}
    </Container>
  );
};

export default RefuelStatus;
